import React from "react";
import { Container, IconTextConatiner, Icon, Text } from "./styles/backButton";

export default function BackButton({children, ...props}){
    return <Container {...props}>{children}</Container>
}

BackButton.IconTextConatiner = function BackButtonIconTextConatiner({children, ...props}){
    return <IconTextConatiner {...props}>{children}</IconTextConatiner>
}

BackButton.Icon = function BackButtonIcon({...props}){
    return <Icon {...props} />
}

BackButton.Text = function BackButtonIcon({children, ...props}){
    return <Text {...props}>{children}</Text>
}